import { createRouter, createWebHashHistory } from 'vue-router'
import Index from '../views/Index.vue'
import Login from '../views/login.vue'
import test from '../views/test.vue'
import store from '@/store'
const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})
router.beforeEach((to, from, next) => {
  const user = store.state.user

  if (!user.token && to.path === '/') {
    return next('/login')
  }
  next()
})
export default router
